// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ProductsApp-components-View-view-module__root","container":"applications-components-ProductsApp-components-View-view-module__container","yourDesignHere":"applications-components-ProductsApp-components-View-view-module__yourDesignHere","image":"applications-components-ProductsApp-components-View-view-module__image","loader":"applications-components-ProductsApp-components-View-view-module__loader"};
    if(module.hot) {
      // 1791528099583
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  